module.exports = __webpack_public_path__ + "img/36.777cc232.png";